import { render, staticRenderFns } from "./showBigXs.vue?vue&type=template&id=6ee5ec6e&scoped=true"
import script from "./showBigXs.vue?vue&type=script&lang=js"
export * from "./showBigXs.vue?vue&type=script&lang=js"
import style0 from "./showBigXs.vue?vue&type=style&index=0&id=6ee5ec6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee5ec6e",
  null
  
)

export default component.exports